export const VERSION_POLLING_REQUESTED = 'VERSION_POLLING_REQUESTED';
export const VERSION_POLLING_SUCCEEDED = 'VERSION_POLLING_SUCCEEDED';
export const VERSION_POLLING_FAILED = 'VERSION_POLLING_FAILED';
export const VERSION_POLLING_CANCELED = 'VERSION_POLLING_CANCELED';
